import {useState} from "react";

const Tab = (props) => {

    const tabName = props.tabName;
    const selected = props.selected;
    const handleClick = props.onClick;

    return (
        <p
            key={tabName}
            onClick={() => handleClick(tabName)}
            className={selected === tabName ? 'tab-selected tab' : 'tab' }
        >
            {tabName}
        </p>
    )
}

const TabRow = (props) => {
    const [selected, setSelected] = useState(props.selected);

    const onChange = (selected) => {
        setSelected(selected);
        if(props.onChange) {
            props.onChange(selected)
        }
    };

    return (
        <div className="tab-row">
            {props.tabs.map((tabName) => (
                <Tab key={tabName} tabName={tabName} onClick={onChange} selected={selected}></Tab>
            ))}
        </div>
    );
};

export default TabRow;
